// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class LongUserName extends Component {
  static propTypes = {
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string
    })
  };

  render() {
    const { className, style, user } = this.props;
    return (
      <span className={className} style={style}>
        {user.displayName}
      </span>
    );
  }
}